import React from 'react'
import BaseComponent from '../../../common/base';
import { Card, Button } from 'react-bootstrap';
import QuestionnairePartialCard from '../../partials/card';
import CanvasDraw from "react-canvas-draw";

export class StepDrawClock extends BaseComponent {

    constructor(props) {
        super(props);

        this.state = Object.assign(
            this.state,
            {
                color: "#000000",
                width: `100%`,
                height: `50vh`,
                brushRadius: 4,
                lazyRadius: 0
            }
        );

        this.canvasDraw = React.createRef();
    }

    onSubmit(e) {
        e.preventDefault();
        this.props.dbSet('draw.clock.reactionTime', this.firstReactionTime());
        this.props.dbSet('draw.clock.responseTime', this.sinceMount());
        this.props.dbSet('draw.clock.pictureData', JSON.parse(this.canvasDraw.getSaveData()));
        this.props.nextStep();
    }

    render() {
        return (
            <>
                <QuestionnairePartialCard
                    onSubmit={(e) => this.onSubmit(e)}
                    title={this.t(`questionnaire.draw.clock.title`)}
                    body={
                        <>
                            <Card.Text>
                                {this.t(`questionnaire.draw.clock.text`)}
                            </Card.Text>
                            <CanvasDraw
                                ref={(canvasDraw) => { this.canvasDraw = canvasDraw; }}
                                brushColor={this.state.color}
                                brushRadius={this.state.brushRadius}
                                lazyRadius={this.state.lazyRadius}
                                canvasWidth={this.state.width}
                                canvasHeight={this.state.height}
                                onChange={() => { this.measureReaction() }}
                            />
                        </>
                    }
                    footer={
                        <Button type="submit" variant="primary">
                            {this.t(`questionnaire.common.saveAndNextStep`)}
                        </Button>
                    }
                />
            </>
        )
    }

}

export default StepDrawClock;